<template>
  <div ref="chart">
    <Chart :extendData="extendData" :height="height" :id="id" :route="route"
           :option="option" :width="width"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';
import china from 'echarts/map/json/china.json';
import echarts from 'echarts';

export default {
  name: "MapChart",
  components: {Chart},
  props: {
    data: null,
    extendData: null,
    route: {
      type: String,
      default: ""
    },
  },
  mounted() {
    this.getOption(this.data)
  },
  data() {
    return {
      id: "pieChart",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  watch: {
    data() {
      this.getOption();
    }
  },
  methods: {
    hidden() {
      this.option.series = this.option.series.map(item => {
        if (item.type === 'lines') {
          item.data = []
        }
        return item;
      })
    },
    show() {
      this.option.series = this.option.series.map(item => {
        if (item.type === 'lines') {
          item.data = this.convertData(this.data)
        }
        return item;
      })
    },
    convertData(data) {
      const geoCoordMap = {
        '台湾': [121.5135, 25.0308],
        '黑龙江': [127.9688, 45.368],
        '内蒙古': [110.3467, 41.4899],
        "吉林": [125.8154, 44.2584],
        '北京': [116.4551, 40.2539],
        "辽宁": [123.1238, 42.1216],
        "河北": [114.4995, 38.1006],
        "天津": [117.4219, 39.4189],
        "山西": [112.3352, 37.9413],
        "陕西": [109.1162, 34.2004],
        "甘肃": [103.5901, 36.3043],
        "宁夏": [106.3586, 38.1775],
        "青海": [101.4038, 36.8207],
        "新疆": [87.9236, 43.5883],
        "西藏": [91.11, 29.97],
        "四川": [103.9526, 30.7617],
        "重庆": [108.384366, 30.439702],
        "山东": [117.1582, 36.8701],
        "河南": [113.4668, 34.6234],
        "江苏": [118.8062, 31.9208],
        "安徽": [117.29, 32.0581],
        "湖北": [114.3896, 30.6628],
        "浙江": [119.5313, 29.8773],
        "福建": [119.4543, 25.9222],
        "江西": [116.0046, 28.6633],
        "湖南": [113.0823, 28.2568],
        "贵州": [106.6992, 26.7682],
        "云南": [102.9199, 25.4663],
        "广东": [113.12244, 23.009505],
        "广西": [108.479, 23.1152],
        "海南": [110.3893, 19.8516],
        '上海': [121.4648, 31.2891],
      };
      const res = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].value > 0) {
          let name = data[i].name
          if (name.indexOf("黑龙江") < 0 && name.indexOf("内蒙古") < 0) {
            name = name.substring(0, 2)
          } else {
            name = name.substring(0, 3)
          }
          const geoCoord = geoCoordMap[name];
          if (geoCoord) {
            res.push({
              name: name,
              value: geoCoord.concat(data[i].value),
              coords: [geoCoord.concat(data[i].value), [geoCoord[0] > 108 ? geoCoord[0] + 30 : geoCoord[0] - 30, geoCoord[1] + 5, data[i].value]],
              citySpaceList: data[i].citySpaceList,
              status: data[i].status ? data[i].status : 0
            });
          }
        }
      }
      return res;
    },
    //显示效果,10秒后隐藏,再过5秒后显示
    effect() {
      setInterval(() => {
        this.hidden();
        setTimeout(() => {
          this.show();
        }, 5000)
      }, 15000)
    },
    getOption() {
      echarts.registerMap('china', china);
      this.effect();
      this.option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            if (params.componentSubType === 'map') {
              if (typeof (params.data) == "object") {
                if (typeof (params.data.value)[2] == "undefined") {
                  return params.name + ' : ' + 0;
                } else {
                  return params.name + ' : ' + params.data.value[2];
                }
              } else {
                if (params.data) {
                  return params.name + ' : ' + params.value;
                } else {
                  return params.name + ' : ' + 0;
                }
              }
            }
          }
        },
        legend: {
          orient: 'vertical',
          y: 'bottom',
          x: 'right',
          data: ['pm2.5'],
          textStyle: {
            color: '#fff'
          }
        },
        visualMap: {
          show: false,
          calculable: true,
          seriesIndex: '0',
          type: "piecewise",
          min: 0,
          max: 500,
          left: 'left',
          pieces: [{
            gte: 0,
            color: "#396cb5"
          }],
          top: 'bottom',
          text: ['高', '低'], // 文本，默认为数值文本
          inRange: {}
        },
        geo: {
          map: 'china',
          aspectScale: 0.75, //长宽比
          show: true,
          roam: false,
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false,
            }
          },
          itemStyle: {
            normal: {
              areaColor: 'rgba(255,255,255,0)',//#3a7fd5
              borderColor: '#007d9a',//线
              shadowOffsetX: 0,
              shadowColor: '#007d9a',
              shadowOffsetY: 13,
            },
            emphasis: {
              areaColor: '#010b24',//悬浮区背景//#0a2dae
            }
          },
          regions: [{
            name: '南海诸岛',
            itemStyle: {
              areaColor: 'rgba(0, 10, 52, 1)',
              borderColor: 'rgba(0, 10, 52, 1)',
              normal: {
                opacity: 0,
                label: {
                  show: false,
                  color: "#009cc9",
                }
              },
            },
            label: {
              show: false,
              color: '#FFFFFF',
              fontSize: 12,
            },
          }],
        },
        series: [
          {
            type: 'map',
            map: 'china',
            // geoIndex: 0,
            aspectScale: 0.75, //长宽比
            showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false,
                textStyle: {
                  color: '#fff'
                }
              }
            },
            roam: false, //放大缩小
            itemStyle: {
              normal: {
                areaColor: '#13457f',
                borderColor: '#00c4ff',
              },
              emphasis: {
                areaColor: '#2082cd',//悬浮区背景//#0a2dae
              }
            },
            animation: false,
            data: this.convertData(this.data),
          },
          // 散点 effectScatter
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 5,
            symbolSize: 10,
            rippleEffect: { //坐标点动画
              period: 3,
              scale: 5,
              brushType: 'fill'
            },
            label: {
              show: false
            },
            data: this.convertData(this.data),
            itemStyle: { //坐标点颜色
              normal: {
                show: true,
                color: (params) => {
                  return params.data.status ? 'rgba(255, 67, 76, 1)' : 'rgba(0, 227, 246, 1)'
                },
                shadowBlur: 10,
                shadowColor: '#fff'
              },
              emphasis: {
                areaColor: '#f00'
              }
            },
          },

          {
            type: 'lines',
            zlevel: 2,
            cursor: 'default',
            symbol: ['none', 'circle'],
            symbolSize: [5, 5],
            color: '#ff8003',
            opacity: 1,
            curveness: true,
            label: {
              show: true,
              position: 'end',
              padding: [10, 20],
              // distance: 10,
              color: '#fff',
              backgroundColor: "transparent",
              borderColor: '#014057',
              borderWidth: 1,
              borderRadius: 4,
              formatter(params) {
                const citySpaceList = params.data.citySpaceList;
                let arr = ""
                if (citySpaceList.length > 0) {
                  for (let i = 0; i < citySpaceList.length; i++) {
                    let item = '\n' + '{cityName|' + citySpaceList[i].cityName + '}' + '\n'
                    let spaceList = citySpaceList[i].spaceList;
                    if (spaceList.length > 0) {
                      for (let j = 0; j < spaceList.length; j++) {
                        let spaceName;
                        if (spaceList[j].status > 0) {
                          spaceName = '{spaceNameRed|' + spaceList[j].cnName + '}'
                        } else {
                          spaceName = '{spaceNameGreen|' + spaceList[j].cnName + '}'
                        }
                        item = item + spaceName + '\n'
                      }
                    }
                    arr = arr + item
                  }
                }
                return arr
              },
              verticalAlign: 'bottom',
              rich: {
                cityName: {
                  align: 'left',
                  lineHeight: 25,
                  fontSize: 12,
                  color: '#fff',
                  // backgroundColor: '#17A597',
                  height: 25,
                  // borderRadius: [4, 4, 0, 0]
                },
                spaceNameRed: {
                  height: 30,
                  color: 'rgba(255, 67, 76, 1)',
                },
                spaceNameGreen: {
                  height: 30,
                  color: 'rgba(0, 227, 246, 1)',
                }
              },
              textStyle: {
                align: 'left',
                lineHeight: 20,
              },
            },
            lineStyle: {
              type: 'solid',
              // color: '#014057',
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(0, 227, 246, 1)' // 0% 处的颜色
                }, {
                  offset: 1, color: '#014057' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              },
              width: 0.5,
              opacity: 1,
              curveness: 0.1

            },
            data: this.convertData(this.data),
          }
        ]
      };
    },
  }
}
</script>

<style scoped>

</style>
